import React from "react";

function Footer() {
  return (
    <footer>Developed by Aya | ©2021</footer>
  )
}
export default Footer